import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faCheckCircle,
  faCalendarAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
//import { totalmem } from "os";

@Component({
  selector: "app-entregas",
  templateUrl: "./entregaOpcion.component.html",
  styleUrls: ["./entregaOpcion.component.css"],
})
export class EntregaOpcionComponent implements OnInit {
  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoVal = faCheckCircle;
  icoFec = faCalendarAlt;
  icoFac = faFileAlt;
  usuarioActual: any;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  modoLis = 0;
  formLis = 0;
  SwDetal = false;
  SwTotal = false;
  SwExcel = false;
  SwImpre = false;
  SwLista = false;
  SwGrafi = false;
  resul: boolean;

  prifec: string;
  ultfec: string;

  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;

  fincas: any[] = [];

  icoFecha: any;

  pasoActual = 1;
  resultado = false;

  constructor(
    private srvCentral: CentralService,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const now = new Date();
    this.fecdia = now.toLocaleString("es-ES");
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.PnsModoLis;
    this.formLis = this.srvCentral.PnsFormLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    switch (this.modoLis) {
      case 0:
        this.SwDetal = true;
        break;
      case 1:
        this.SwTotal = true;
        break;
    }

    switch (this.formLis) {
      case 0:
        this.SwLista = true;
        break;
      case 1:
        this.SwImpre = true;
        break;
      case 2:
        this.SwExcel = true;
        break;
      case 3:
        this.SwGrafi = true;
        break;
    }
  }
  persiana(): void {
    $("#wrapper").toggleClass("toggled");
  }

  irA(ruta: string): void {
    this.router.navigate([ruta]);
  }
}
